'use client';

import { useEffect, useState } from 'react';

import dynamic from 'next/dynamic';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { useUserInfo } from '../../helpers/hooks/useUserInfo';
import { objectToQueryString, queryStringToObject } from '../../helpers/url/queryUtils';
import { Modal } from '../Modal/Modal';
import { ModalHeader } from '../Modal/ModalHeader';

const DynamicPostFormPage = dynamic(async () =>
  import('./PostFormPage').then(mod => mod.PostFormPage),
);

export const PostFormModal = () => {
  const pathname = usePathname();
  const queryParams = useSearchParams();
  const { replace } = useRouter();

  const [modalRenderingDelay, setModalRenderingDelay] = useState(true);
  const { isLoggedIn } = useUserInfo();
  const postModalVisible = queryParams?.get('add_post') && isLoggedIn;

  // TODO-FIB-42586: Test if this is still needed - On same pages portal rendering is too eager and renders visible, to fix this a very small delay is introduced. */
  useEffect(() => {
    setTimeout(() => setModalRenderingDelay(false), 1);
  }, []);

  const closeModal = (): void => {
    // remove add_post from route to close the modal
    const { add_post, ...rest } = queryStringToObject(queryParams?.toString());
    const url = `${pathname}${objectToQueryString(rest) ? `?${objectToQueryString(rest)}` : ''}`;
    replace(url);
  };

  return postModalVisible && !modalRenderingDelay ? (
    <Modal
      isOpen={postModalVisible}
      onClose={closeModal}
      disableClose={{
        disableClickOutside: true,
        disableCloseButton: false,
        disableEscapeKey: true,
      }}
      size="lg"
      style={{ height: '80vh' }}
    >
      <ModalHeader title="Post to Fishbrain" />
      <DynamicPostFormPage />
    </Modal>
  ) : (
    <></>
  );
};
